import {
  IconAdjustmentsAlt,
  IconAppWindow,
  IconBox,
  IconDashboard,
  IconFilePencil,
  IconFriends,
  IconInfoSquare,
  IconMessage,
  IconMessageReport,
  IconReportMoney,
  IconUserPin,
  IconUsers,
  IconUsersPlus,
} from '@tabler/icons-react';
import type { NavbarLink } from './interface';

export const navbarLinks: NavbarLink[] = [
  {
    link: '/',
    label: 'Dashboard',
    icon: IconDashboard,
    // Dashboard is always visible
  },
  {
    link: '/orders',
    label: 'Orders',
    icon: IconReportMoney,
    resource: 'order',
  },
  {
    link: '/products',
    label: 'Products',
    icon: IconBox,
    resource: 'product',
    childLinks: [
      {
        link: '/products',
        label: 'Products',
        resource: 'product',
      },
      {
        link: '/bundles',
        label: 'Bundles',
        resource: 'bundle',
      },
      {
        link: '/products/bestsellers',
        label: 'Best seller',
        resource: 'product',
      },
      {
        link: '/categories',
        label: 'Categories',
        resource: 'category',
      },
      {
        link: '/suggested-questions',
        label: 'Questions',
        resource: 'suggested-question',
      },
    ],
  },
  {
    link: '/content-calendar',
    label: 'Content',
    icon: IconFilePencil,
    resource: 'content',
    childLinks: [
      {
        link: '/content-calendar',
        label: 'Calendar',
        resource: 'content-calendar',
      },
      {
        link: '/content',
        label: 'Medical Content',
        resource: 'content',
      },
      {
        link: '/social-content',
        label: 'Social Content',
        resource: 'social-content',
      },
      {
        link: '/content-briefs',
        label: 'Content briefs',
        resource: 'content-brief',
      },
      {
        link: '/content-categories',
        label: 'Categories',
        resource: 'content-category',
      },
      {
        link: '/visual-content',
        label: 'Visual Content',
        resource: 'visual-content',
      },
      {
        link: '/content-types',
        label: 'Content types',
        resource: 'content-type',
      },
      {
        link: '/content-topics',
        label: 'Content Topics',
        resource: 'content-topic',
      },
      {
        link: '/content-dictionary',
        label: 'Content Dictionary',
        resource: 'content-dictionary',
      },
    ],
  },
  {
    link: '/pages',
    label: 'Pages',
    icon: IconAppWindow,
    resource: 'page',
  },
  {
    link: '/customers',
    label: 'Customers',
    icon: IconUsers,
    resource: 'customer',
  },
  {
    link: '/influencers',
    label: 'Influencers',
    icon: IconUserPin,
    resource: 'influencer',
    childLinks: [
      {
        link: '/influencers',
        label: 'Influencers',
        resource: 'influencer',
      },
      {
        link: '/invitations',
        label: 'Invitations',
        resource: 'invitation',
      },
    ],
  },
  {
    link: '/tips',
    label: 'Tips',
    icon: IconInfoSquare,
    resource: 'tip',
  },
  {
    link: '/conversations',
    label: 'Conversations',
    icon: IconMessage,
    resource: 'conversation',
    childLinks: [
      {
        link: '/conversations',
        label: 'Conversations',
        resource: 'conversation',
      },
      {
        link: '/conversation-feedbacks',
        label: 'Feedbacks',
        resource: 'conversation-feedback',
      },
    ],
  },
  {
    link: '/feedbacks',
    label: 'Feedbacks',
    icon: IconMessageReport,
    resource: 'feedback',
  },
  {
    link: '/team-members',
    label: 'Team members',
    icon: IconFriends,
    resource: 'team-member',
  },
  {
    link: '/subscribers',
    label: 'Subscribers',
    icon: IconUsersPlus,
    resource: 'subscriber',
  },
  {
    link: '/system/users',
    label: 'System',
    icon: IconAdjustmentsAlt,
    resource: 'system',
    childLinks: [
      {
        link: '/system/users',
        label: 'Users',
        resource: 'user',
      },
      {
        link: '/system/permissions',
        label: 'Permissions',
        resource: 'permission',
      },
      {
        link: '/system/files',
        label: 'Files',
        resource: 'file',
      },
      {
        link: '/system/settings',
        label: 'Settings',
        resource: 'setting',
      },
    ],
  },
];
